import type {TFunction} from "i18next";

import {interpolateCatalog} from "@/src/modules/core/i18n";

export function tAmenityAccessLogSheetTitle(
  isEditing: boolean,
  t: TFunction<"amenity_access_log">,
): string {
  return isEditing ? t("sheet.update_title") : t("sheet.new_title");
}

export function tAmenityAccessLogSubmitLabel(
  isEditing: boolean,
  t: TFunction<"amenity_access_log">,
): string {
  return isEditing ? t("sheet.update_title") : t("sheet.submit");
}

export function tAmenityAccessLogFacilityLabel(
  isPool: boolean,
  facilitySingular: string,
  t: TFunction<"amenity_access_log">,
): string {
  return isPool ? t("form.pool") : facilitySingular;
}

export function tAmenityAccessLogFacilityRequired(
  isPool: boolean,
  facilityLabel: string,
  t: TFunction<"amenity_access_log">,
): string {
  return isPool
    ? t("validation.pool_required")
    : t("validation.facility_required");
}

export function tAmenityAccessLogGuestLimitAlert(
  count: number,
  t: TFunction<"amenity_access_log">,
): string {
  return t("alert.guest_limit", {count});
}

export function tAmenityAccessLogDetailsCharCount(
  count: number,
  max: number,
  t: TFunction<"amenity_access_log">,
): string {
  return t("form.details_char_count", {count, max});
}

export function tAmenityAccessLogImagePickerLabels(
  fileCount: number,
  maxFiles: number,
  t: TFunction<"amenity_access_log">,
) {
  return {
    camera: t("form.camera"),
    gallery: t("form.gallery"),
    removeImage: t("form.remove_image"),
    imagesCount: interpolateCatalog(t("form.images_count"), {
      count: fileCount,
      max: maxFiles,
    }),
    maxFilesExceeded: interpolateCatalog(t("form.max_images"), {max: maxFiles}),
  };
}
